<style scoped>
    @import url("../../styles/smartControl/defSmartControl.scss");
</style>

<template>
    <div class="box_defDaySC">

        <!-- MAIN TIT -->
        <div class="titGeral">
            <v-icon :style="{'color':'rgb(31,122,177)'}">mdi-calendar-clock</v-icon>
            <span class="ml-2">Agenda periódica</span>
        </div>

        <!-- Caixa de diálogo aberta após input de atualização -->
        <v-dialog v-model="flagDialog" max-width="250px">
            <div v-if="!flagLoading && flagDialog">
                <DialogMsg 
                v-if="flagDialog" 
                :msgFromFather="msg2child"
                @fromDialogMsg="flagDialog = false" 
                />
            </div>
        </v-dialog>

        <!-- Msg de info para quando não houver atuadores periódicos -->
        <div :style="{'align-self':'center'}" v-if="!flagLoading && !flagActiveP"
        >Nenhum controlador com atuação periódica registado.</div>

        <!-- LOADING após search btn -->
        <div v-if="flagLoading" class="mb-16 mt-16"
        :style="{'display':'flex','width':'100%','align-items':'center','justify-content':'center'}">
            <v-progress-circular 
                color="black"
                size="64"
                indeterminate
            ></v-progress-circular>
        </div>

        <div class="painelGeral" v-if="!flagLoading && flagActiveP">

            <v-btn 
            @click="openForm()"
            class=""
            height="60px"
            width="100%"
            density="comfortable"
            block
            :style="{'color':'green','white-space':'normal !important'}"
            >
                <v-icon class="mr-1" size="16">mdi-plus</v-icon>
                <span>novo agendamento</span>
            </v-btn>

            <!-- FORM -->
            <FormDefDay class="mt-2" v-if="flagForm" @formResult="handleFromForm($event)" />

        </div>

        <!-- INFO -->
        <div class="tit2 mt-2" v-if="!flagLoading && flagActiveP">
            <v-chip class="" color="white">As alterações serão aplicadas no dia seguinte</v-chip>
        </div>

        <!-- TIT -->
        <div class="tit2 mt-4 ml-2" v-if="!flagLoading && flagActiveP">Definição periódica atual</div>

        <!-- MSG ERRO -->
        <div class="mt-2 mb-2" v-if="liP.length == 0 && flagActiveP" :style="{'align-self':'center'}"
        >Nenhum agendamento periódico registado.</div>

        <!-- PAINEL -->
        <div class="painel2" v-if="!flagLoading && flagActiveP">

            <!-- LARGE CARD hidden-sm-and-down -->
            <div class="card_agend mb-2" v-for="(el,k) in liP" :key="k">

                <!--<div class="el_edit"
                @mouseover="corEdit='#F39C12'"
                @mouseleave="corEdit=''"
                :style="{'background':corEdit}"><v-icon>mdi-pencil-outline</v-icon></div>-->
                
                <div class="card_chips">
                    <v-chip class="el_chip" color="#397E9E">{{ el.hhmm }}</v-chip>
                    <v-chip class="el_chip" color="#397E9E">{{ el.device }}</v-chip>
                    <v-chip class="el_chip" color="#397E9E">{{ el.titulo_atuador }}</v-chip>

                    <v-chip class="el_chip" color="#397E9E" v-if="el.timeout_tempo_hr">Temporizado</v-chip>
                    <v-chip class="el_chip" color="#397E9E" v-else>{{ el.tipo }}</v-chip>
                    
                    <v-chip class="el_chip" color="#397E9E" v-if="el.timeout_tempo_hr">{{ el.timeout_tempo_hr }}</v-chip>
                    <v-chip class="el_chip" color="#397E9E" v-else>{{ el.atu }}</v-chip>

                    <v-chip class="el_chip" color="#397E9E">{{ el.pino_atuador }}</v-chip>
                </div>

                <div @click="cancelEl(k)"
                class="el_edit"
                @mouseover="el.corX='red'"
                @mouseleave="el.corX=''"
                :style="{'background':el.corX}">
                    <v-icon>mdi-close-octagon</v-icon>
                </div>
            </div>

            <v-btn color="green" v-if="flagUp" @click="upP()">Registar alteração</v-btn>
        </div>

    </div>
</template>

<script>
import axios from 'axios'

import FormDefDay from './defDay/FormDefDay'
import DialogMsg  from './defDay/DialogMsg'

import { convHhmmToUtc } from "./auxSC/handleTimeConv.js"; // 04/05/2026
import { convHhmmFromUtc } from "./auxSC/handleTimeConv.js"; // 04/05/2026

export default {

    components:{FormDefDay,DialogMsg},

    data() {
        return {
            
            flagLoading:true, // init true loading em produção
            flagActiveP:false, // permitir exibição se houver atuação periódico
            flagForm:false, // abrir form
            flagUp:false, // abrir update db
            flagDialog:false,
            msg2child:'', // msg enviada ao componente filho após input de atualização.

            // exemplo base para exibição
            liP:[
                {
                    'hhmm':'16:28',
                    'device':'Controlador 1 (tangerina)',
                    'titulo_atuador':'Ventilação',
                    'tipo':'Direto',
                    'atu':'Ligar',
                    'pino_atuador':'04',
                    'corX':'', // <-- adicionado localmente ao receber via req

                    'command_hex':'0804', // <-- nao é exibido no front.
                    'op':'Direto', // <-- nao é exibido no front.
                },
                {
                    'hhmm':'16:28',
                    'device':'Controlador 1 (tangerina)',
                    'titulo_atuador':'Irrigação',
                    'tipo':'Direto',
                    'timeout_tempo_hr':'00:00:08', // substitui "atu" quando é um temporizado
                    'pino_atuador':'08',
                    'corX':'',

                    'command_hex':'0608', // <-- nao é exibido no front.
                    'op':'Timeout', // <-- nao é exibido no front.
                },
            ],
        }
    },

    methods:{

        openForm() { this.flagForm = true; },

        handleFromForm(e) {
            window.scrollTo(0,0)
            //console.log('from form: ',e)

            this.liP.push(e)
            this.liP = this.sortHHMM(this.liP)

            this.flagForm = false; // fechar form
            this.flagUp = true // abrir btn update db (aqui, após 1a event com child)
        },

        sortHHMM(lista) {

            const toMin = (h) => {
                if (typeof h !== "string") return Infinity;
                const p = h.split(":");
                const hh = Number(p[0]);
                const mm = Number(p[1]);
                if (!Number.isFinite(hh) || !Number.isFinite(mm)) return Infinity;
                return hh * 60 + mm;
            };
            return [...lista].sort((a, b) => toMin(a?.hhmm) - toMin(b?.hhmm));
        },

        cancelEl(k) { this.liP = this.liP.filter((_, idx) => idx !== k); this.flagUp = true; },

        HHMMSStoSeconds(hhmmss) {
            const [h, m, s] = hhmmss.split(":").map(Number)
            return (h * 3600) + (m * 60) + s
        },

        upP() {
            this.flagLoading = true // -- open loading
            //console.log('this.liP: ',this.liP) // lista já pronta para o show?
            // -- remover key corX de todos os itens da lista. (para ter que adicionar na chegada? não.)

            // -- conv hhmm para utc.
            const tzName = this.$store.state.fusoHorarioSC // esperado algo como --> "Europe/Lisbon"
            const dataStr = new Date().toLocaleDateString("pt-PT"); // data string no formato pt dd/mm/aaaa
            //console.log('[upP] dataStr: ',dataStr)
            let c=0
            let hhmmmLocal = null
            let hhmmUTC = null
            while (c < this.liP.length) {

                // conv hhmm
                hhmmmLocal = this.liP[c]['hhmm']
                //console.log('[upP] hhmmmLocal: ',hhmmmLocal)
                hhmmUTC = convHhmmToUtc(hhmmmLocal, tzName, dataStr)
                //console.log('[upP] hhmmUTC: ',hhmmUTC)
                this.liP[c]['hhmm'] = hhmmUTC

                // conv timeout_tempo_hr <'hh:mm:ss'> para tempo_segundos <segundos>
                const timeout_tempo_hr = this.liP[c]['timeout_tempo_hr']
                // adicionar key 'tempo_segundos' inteiro para os agend timeout
                if (timeout_tempo_hr) {
                    const tempo_segundos = this.HHMMSStoSeconds(timeout_tempo_hr)
                    this.liP[c]['tempo_segundos'] = tempo_segundos
                }

                c++
            }

            this.sistema = this.$store.state.sistemaSC
            let cl = this.$store.state.emailCliente

            const headers = {
                'Authorization': `Bearer ${this.$store.state.tox}`,
                'Content-Type': 'application/json'
            }

            let params = {'cliente':cl, 'sistema':this.sistema, 'li_periodica':this.liP}

            let self = this
            const url = self.$store.state.pathAxiosBASE + '/upperiodo'
            axios.post(url, params, {headers}).then(function (res) {

                //console.log(res.data.result) // agent 
                const strConfirm = res.data.result // agent_unit

                if (strConfirm == 'ok') {self.msg2child = 'Atualizado.'}
                else {self.msg2child = 'Não foi possível atualizar. Tente novamente mais tarde.'}
                self.flagDialog = true // abrir dialog com informações do input feito.

                // -- reset
                self.init(self.liP) // montar novamente a lista para exibição
                //self.flagLoading = false // -- encerrar loading
                //self.flagUp = false // -- manter btn update desabilitado até ocorrer a 1a interacao com child ou cancel
            })

        },
    
        init(liPeriodo) {

            // -- conv hhmm utc para hhmm local.
            const tzName = this.$store.state.fusoHorarioSC // esperado algo como --> "Europe/Lisbon"
            const dataStr = new Date().toLocaleDateString("pt-PT"); // data string no formato pt dd/mm/aaaa
            //console.log('[upP] dataStr: ',dataStr)
            let c=0
            let hhmmLocal = null
            let hhmmUTC = null
            while (c < liPeriodo.length) {
                hhmmUTC = liPeriodo[c]['hhmm']
                //console.log('[init] hhmmUTC: ',hhmmUTC)
                hhmmLocal = convHhmmFromUtc(hhmmUTC, tzName, dataStr)
                //console.log('[init] hhmmmLocal: ',hhmmmLocal)
                liPeriodo[c]['hhmm'] = hhmmLocal
                c++
            }

            this.liP = liPeriodo // -- lista de exibição
            //console.log('liP: ',this.liP)
            this.flagActiveP = true // -- existe pelo menos 1 atuador período ativo
            this.flagLoading = false // -- encerrar loading
            this.flagUp = false // -- manter btn update desabilitado até ocorrer a 1a interacao com child ou cancel
        },

        preInit() {

            this.liP = [] // reset exemplo de exibição

            this.sistema = this.$store.state.sistemaSC
            let cl = this.$store.state.emailCliente

            const headers = {
                'Authorization': `Bearer ${this.$store.state.tox}`,
                'Content-Type': 'application/json'
            }

            let self = this

            let params = {'cliente':cl, 'sistema':this.sistema}

            axios.post(self.$store.state.pathAxiosAgentIA, params, {headers}).then(function (res) {

                //console.log(res.data.result) // agent 
                const el = res.data.result // agent_unit
                let liPeriodo = el['periodo'] // lista contendo os agendamentos periodicos atuais (pode está vazia)

                let flagExib = false // gatilho de exibição (basta que existe um atuador periódico ativo)
                let liAtuadores = el['atuadores'] // lista de controladores contendo atuadores (pinos)
                let c=0
                while ( c < liAtuadores.length ) {

                    let params = liAtuadores[c]['params']
                    let j=0
                    while (j < params.length) {

                        if (params[j]['status'] == 'on' && params[j]['modelo'] == 'Periodico') { flagExib = true; break; }
                        j++
                    }
                    c++
                }

                // -- chamar início da lista após verificação de existência.
                if (flagExib) { self.init(liPeriodo) }
                else { self.flagActiveP = false; self.flagLoading = false } // exibir msg de erro: não há atuador periódico
            })
        },
    },

    created() {
        window.scrollTo(0,0)
        this.preInit()
    }
}
</script>